/**
 * App-scoped OSP security worker (CSR). Shared by factories, hooks, and auth composite.
 */

import { config } from "@/src/config";

import { getEnvIndexBaseUrl } from "./constants";
import { createOspSecurityWorker } from "./ospSecurity";

export const appOspSecurity = createOspSecurityWorker({
  indexBaseUrl: getEnvIndexBaseUrl(config.osp.environment),
  appId: config.osp.appId,
});
